import { render, staticRenderFns } from "./ReportsMovements.vue?vue&type=template&id=fe13f37a&"
import script from "./ReportsMovements.vue?vue&type=script&lang=js&"
export * from "./ReportsMovements.vue?vue&type=script&lang=js&"
import style0 from "./ReportsMovements.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports